

export const createUniqueKey = (match) => {
    return `${match.id}_${match.dateTime}_${match.marketType}_${match.runnerName}`;
  };